/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Users/User': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M16 16.5c-6.28 0-10 2.813-10 7v3.75c0 .138.112.25.25.25h1.5a.25.25 0 0 0 .25-.25V23.5c0-3.454 3.769-5 8-5 3.867 0 8 1.313 8 5v2H11.082a.252.252 0 0 0-.228.146l-.69 1.5a.25.25 0 0 0 .227.354H25.75a.25.25 0 0 0 .25-.25V23.5c0-4.253-3.926-7-10-7m0-11c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m0 10a6 6 0 0 0 0-12 6 6 0 0 0 0 12"/>'
  }
})
